import { render } from "./integrallist2.vue?vue&type=template&id=44886b1e"
import script from "./integrallist2.vue?vue&type=script&lang=js"
export * from "./integrallist2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__